import ltStepperProgress from 'html/shopping-cart/lt-stepper-progress.html';
import App from 'app/app.js';

function LtStepperProgressDirective() {
  return {
    restrict: 'E',
    scope: {
      currentPage: '='
    },
    template: ltStepperProgress,
    controller: 'LtStepperProgressCtrl',
    controllerAs: 'stepperProgress'
  };
}
App.directive('ltStepperProgress', [LtStepperProgressDirective]);
